import cx from 'classnames'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { removeTicket } from '../../../../../../components/Basket/reducer'
import Icon from '../../../../../../components/Icon/Icon'
import Ticket from '../../../../../../components/Ticket/Ticket'
import ToggleButton from '../../../../../../components/ToggleButtonRow/components/ToggleButton/ToggleButton'
import ToggleButtonRow from '../../../../../../components/ToggleButtonRow/ToggleButtonRow'
import TicketDelete from '../TicketDelete/TicketDelete'
import { DEFAULT_TICKET_CATEGORY_BUTTON } from './constants'

import hocConnect from './hocConnect'

import './TicketRow.scss'

const TicketRow = ({ data, changeTicketCategory, loading }) => {
    const [isDelete, setIsDelete] = useState(false)
    const [dropdownOpen, setDropdownMenu] = useState(false)
    const dispatch = useDispatch()

    const handleDelete = () => {
        dispatch(removeTicket([data.ticketid]))
        setIsDelete(false)
    }
    const allowedCustomerCategories = data?.allowed_customer_categories ?? []
    const categoryBtns = [DEFAULT_TICKET_CATEGORY_BUTTON, ...allowedCustomerCategories]

    return (
        <>
            <div className={'ticket-row'}>
                <Ticket
                    seat={{ type: 'classic', label: `${data?.row} ${data?.seat}` }}
                    price={{ amount: data?.price, currency: 'CZK' }}
                    className={cx(isDelete && 'opacity-50')}
                />
                <ToggleButtonRow
                    btns={categoryBtns}
                    selected={data?.customer_category?.customer_categoryid}
                    disabled={!data?.can_use_customer_category || loading}
                    withBorderRadius
                    isShrinkable
                    classNameShrink={cx('d-md-none', isDelete && 'opacity-50')}
                    dropdownOpen={dropdownOpen}
                    setDropdownMenu={setDropdownMenu}
                />

                {isDelete ? (
                    <TicketDelete
                        className={'d-none d-md-flex'}
                        handleYes={handleDelete}
                        handleNo={() => setIsDelete(false)}
                    />
                ) : (
                    <ToggleButtonRow
                        btns={categoryBtns}
                        selected={data?.customer_category?.customer_categoryid}
                        disabled={!data?.can_use_customer_category || loading}
                        withBorderRadius
                        ticketId={data?.ticketid}
                        onClick={changeTicketCategory}
                        isShrinkable
                        classNameShrink={cx('d-none d-md-flex', isDelete && 'opacity-50')}
                    />
                )}
                <Icon
                    name="trash"
                    role={'button'}
                    className={'my-auto ms-auto'}
                    onClick={() => setIsDelete(true)}
                    disable={isDelete || loading}
                />
            </div>

            <TicketDelete
                className={cx('d-md-none', !isDelete && 'd-none')}
                handleYes={handleDelete}
                handleNo={() => setIsDelete(false)}
            />

            <div className={cx('d-md-none toggle-btn-row d-flex', !dropdownOpen && 'd-none')}>
                {categoryBtns.map((btn) => (
                    <ToggleButton
                        key={`toggle-btn-group-btn-${btn?.customer_categoryid}`}
                        id={btn?.customer_categoryid}
                        disabled={!data?.can_use_customer_category || loading}
                        active={data?.customer_category?.customer_categoryid === btn?.customer_categoryid}
                        labelId={btn?.name}
                        onClick={() => changeTicketCategory({ id: btn?.customer_categoryid, ticketId: data?.ticketid })}
                        withBorderRadius
                    />
                ))}
            </div>
        </>
    )
}

export default hocConnect(TicketRow)
